import useScrollFlags from '../hooks/useScrollFlags';
import './BackToTop.css';

export default function BackToTop() {
  const { showBackToTop } = useScrollFlags();

  if (!showBackToTop) return null;

  return (
    <button
      className="btt"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M7 14L12 9L17 14" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
}
